const organizations = {
    require_membership: 'The user must be a member of the organization to proceed.',
};
export default Object.freeze(organizations);
